<app-admin-modal title="Remove duplicate leads" size="2xl" (closed)="close()">
  @if (loading()) {
    <p class="cg-form-help">Scanning leads for duplicate names…</p>
  } @else if (error()) {
    <p class="cg-form-help cg-form-help--error" role="alert">{{ error() }}</p>
    <div class="lead-duplicates-modal__actions">
      <app-admin-button variant="secondary" type="button" (click)="close()">Close</app-admin-button>
      <app-admin-button variant="primary" type="button" (click)="loadPreview()">Retry</app-admin-button>
    </div>
  } @else {
  @let data = preview();
  @if (!data || data.totalGroups === 0) {
    <app-admin-empty-state
      icon="users"
      title="No duplicate names found"
      description="Leads are compared by name (case-insensitive). No duplicate names were found."
    />
    <div class="lead-duplicates-modal__actions">
      <app-admin-button variant="secondary" type="button" (click)="close()">Close</app-admin-button>
    </div>
  } @else {
    <p class="cg-form-help lead-duplicates-modal__summary">
      Found <strong>{{ data.totalGroups }}</strong> duplicate name{{ data.totalGroups === 1 ? '' : 's' }}.
      Choose <strong>Keep</strong> or <strong>Delete</strong> for each lead below.
      At least one lead per name must be kept.
      <strong>{{ totalToDelete() }}</strong> selected for deletion.
    </p>

    <div class="lead-duplicates-modal__table-wrap">
      <app-admin-table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Destination</th>
            <th>Status</th>
            <th>Assigned to</th>
            <th>Created</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (row of flatRows(); track row.lead._id) {
            <tr
              [class.lead-duplicates-row--delete]="row.lead.action === 'delete'"
              [class.lead-duplicates-row--keep]="row.lead.action === 'keep'"
            >
              <td>
                <strong>{{ row.lead.fullName }}</strong>
                @if (row.group.leads[0]._id === row.lead._id && row.group.leads.length > 1) {
                  <div class="cg-form-help">{{ row.group.leads.length }} records with this name</div>
                }
              </td>
              <td>{{ row.lead.email || '—' }}</td>
              <td>{{ row.lead.phoneNumber || '—' }}</td>
              <td>{{ row.lead.preferredDestination || '—' }}</td>
              <td>{{ row.lead.statusName || '—' }}</td>
              <td>{{ row.lead.assignedTo || '—' }}</td>
              <td>{{ row.lead.createdAt ? (row.lead.createdAt | date: 'medium') : '—' }}</td>
              <td>
                <div class="lead-duplicates-action-cell">
                  <div class="lead-duplicates-action-toggle" role="group" [attr.aria-label]="'Action for ' + row.lead.fullName">
                    <button
                      type="button"
                      class="lead-duplicates-action-toggle__btn"
                      [class.lead-duplicates-action-toggle__btn--active]="row.lead.action === 'keep'"
                      [attr.aria-pressed]="row.lead.action === 'keep'"
                      (click)="setAction(row.lead._id, 'keep')"
                    >
                      Keep
                    </button>
                    <button
                      type="button"
                      class="lead-duplicates-action-toggle__btn lead-duplicates-action-toggle__btn--delete"
                      [class.lead-duplicates-action-toggle__btn--active]="row.lead.action === 'delete'"
                      [attr.aria-pressed]="row.lead.action === 'delete'"
                      (click)="setAction(row.lead._id, 'delete')"
                    >
                      Delete
                    </button>
                  </div>
                  @if (row.group.leads[0]._id === row.lead._id && row.group.leads.length > 1) {
                    <button
                      type="button"
                      class="lead-duplicates-merge-btn"
                      (click)="requestMerge(row.group)"
                    >
                      Merge leads
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </app-admin-table>
    </div>

    <div class="lead-duplicates-modal__actions">
      <app-admin-button variant="secondary" type="button" [disabled]="removing()" (click)="close()">
        Cancel
      </app-admin-button>
      <app-admin-button
        variant="danger"
        type="button"
        [disabled]="removing() || !canConfirm()"
        (click)="confirmRemove()"
      >
        {{ removing() ? 'Removing…' : 'Delete ' + totalToDelete() + ' duplicate' + (totalToDelete() === 1 ? '' : 's') }}
      </app-admin-button>
    </div>
  }
  }
</app-admin-modal>
